import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid, Stack } from '@mui/material'
import { push } from '@lagunovsky/redux-react-router'
import { InstallationActionConstant } from 'installation/reducers/InstallationReducer'
import { flatten, isNil, maxBy, omit, uniq, upperFirst } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import { v4 as uuidv4 } from 'uuid'
import Table from '../../../components/datatable/Table'
import Checkbox from '../../../components/forms/Checkbox'
import Input from '../../../components/forms/Input'
import DatePicker from '../../../components/forms/DatePicker'
import NumberField from '../../../components/forms/NumberField'
import RadioButtons from '../../../components/forms/RadioButtons'
import Select from '../../../components/forms/Select'
import SuperMultiAutocomplete from '../../../components/forms/SuperMultiAutocomplete'
import Textarea from '../../../components/forms/Textarea'
import Icon from '../../../components/icon/Icon'
import SelectEmail from '../../../components/modal/SelectEmail'
import SieauAction from '../../../components/sieau/SieauAction'
import EventsAction from '../../../events/actions/EventsAction'
import { EVENT_TYPES, EVENT_TYPES_CODES } from '../../../events/constants/EventsConstants'
import InstallationAction from '../../../installation/actions/InstallationAction'
import { buildCampaignGroups, getInterventionType } from '../../../utils/CampaignUtil'
import { getDate, getDateWithHour, getHour } from '../../../utils/DateUtil'
import { formatHourInput, onChangeDate, onChangeHour, safeBaseDate } from '../../../utils/FormUtils'
import { getUser } from '../../../utils/SettingUtils'
import { execByType, getStation, getStationTitleWithTownName } from '../../../utils/StationUtils'
import { deleteKeys, getSandreList } from '../../../utils/StoreUtils'
import StationAction from '../../actions/StationAction'
import { STATION_TYPE_NAME } from '../../constants/StationConstants'
import DiagnosticSolutionModal from './modal/DiagnosticSolutionModal'
import ProductionUnitAction from 'productionUnit/actions/ProductionUnitAction'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import MaterielAction from 'materiel/actions/MaterielAction'
import { getMaterialStateIcon, getMaterielPlural } from 'utils/MaterielUtils'
import ElementCard from 'components/card/ElementCard'
import useActions from 'utils/customHook/useActions'
import useBoolean from 'utils/customHook/useBoolean'
import useTitle from 'utils/customHook/useTitle'
import { LastUpdateCard } from 'components/card/LastUpdateCard'
import { CardTitle } from 'components/card/NewCard'
import { darkBlue } from 'utils/constants/ColorTheme'
import EventControlMeasuresCard, { getControlsToSave, getLevelControl, hasInvalidControls } from 'events/components/EventControlMeasuresCard'

const CAUSE_INTERVENTION_TYPES = ['hydrometry', 'pluviometry', 'installation']

const UNIT_TYPES = ['productionUnit', 'distributionUnit']

const NO_MAILS = {
    mailContacts: [],
    mailContributors: [],
    mailCities: [],
    mailReceivers: [],
}

const StationEventApp = ({
    type = '',
}) => {
    const dispatch = useDispatch()
    const { id, code } = useParams()
    const hasControlMeasures = [STATION_TYPE_NAME.hydrometry, STATION_TYPE_NAME.pluviometry].includes(type)
    const location = useLocation()

    const {
        qualitometer,
        piezometer,
        pluviometer,
        hydrometricStation,
        productionUnit,
        distributionUnit,
        installation,
        installationEvent,
        productionUnitEvent,
        storeEvent,
        contacts,
        contributors,
        citiesIndex,
        sandreCodes,
        materielStates,
        stationCentral,
        stationPowerSupply,
        stationSensor,
        stationSim,
        stationTelecom,
        stationVariousMateriel,
        stationEquipment,
        eventPiezometerDiagnostics,
        eventPiezometerDiagnosticsLinkMaterials,
        eventPiezometerDiagnosticsLinkEventTypes,
        eventPiezometerSolutions,
        eventPiezometerSolutionsLinkProblems,
        eventPiezometerActions,
        pluviometryCampaigns,
        pluviometryCampaignStations,
        hydrometryCampaigns,
        hydrometryCampaignStations,
        qualityCampaigns,
        qualityCampaignStations,
        installationCampaigns,
        installationCampaignStations,
        materiels,
    } = useSelector(store => ({
        qualitometer: store.QualityReducer.qualitometer,
        piezometer: store.StationReducer.piezometer,
        pluviometer: store.PluviometryReducer.pluviometer,
        hydrometricStation: store.HydrometryReducer.hydrometricStation,
        productionUnit: store.ProductionUnitReducer.productionUnit,
        distributionUnit: store.DistributionUnitReducer.distributionUnit,
        installation: store.InstallationReducer.installation,
        installationEvent: store.InstallationReducer.installationEvent,
        productionUnitEvent: store.ProductionUnitReducer.productionUnitEvent,
        storeEvent: store.EventsReducer.event,
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
        citiesIndex: store.CityReducer.citiesIndex,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        materielStates: store.MaterielReducer.materielStates,
        stationCentral: store.StationReducer.stationCentral,
        stationPowerSupply: store.StationReducer.stationPowerSupply,
        stationSensor: store.StationReducer.stationSensor,
        stationSim: store.StationReducer.stationSim,
        stationTelecom: store.StationReducer.stationTelecom,
        stationVariousMateriel: store.StationReducer.stationVariousMateriel,
        stationEquipment: store.StationReducer.stationEquipment,
        eventPiezometerDiagnostics: store.EventsReducer.eventPiezometerDiagnostics,
        eventPiezometerDiagnosticsLinkMaterials: store.EventsReducer.eventPiezometerDiagnosticsLinkMaterials,
        eventPiezometerDiagnosticsLinkEventTypes: store.EventsReducer.eventPiezometerDiagnosticsLinkEventTypes,
        eventPiezometerSolutions: store.EventsReducer.eventPiezometerSolutions,
        eventPiezometerSolutionsLinkProblems: store.EventsReducer.eventPiezometerSolutionsLinkProblems,
        eventPiezometerActions: store.EventsReducer.eventPiezometerActions,
        pluviometryCampaigns: store.PluviometryReducer.pluviometryCampaigns,
        pluviometryCampaignStations: store.PluviometryReducer.pluviometryCampaignStations,
        hydrometryCampaigns: store.HydrometryReducer.hydrometryCampaigns,
        hydrometryCampaignStations: store.HydrometryReducer.hydrometryCampaignStations,
        qualityCampaigns: store.QualityReducer.qualityCampaigns,
        qualityCampaignStations: store.QualityReducer.qualityCampaignStations,
        installationCampaigns: store.InstallationReducer.installationCampaigns,
        installationCampaignStations: store.InstallationReducer.installationCampaignStations,
        materiels: {
            centrals: store.CentralReducer.centrals,
            centralTypes: store.CentralReducer.centralTypes,
            powerSupplies: store.PowerSupplyReducer.powerSupplies,
            powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
            sensors: store.SensorReducer.sensors,
            sensorTypes: store.SensorReducer.sensorTypes,
            sims: store.SimReducer.sims,
            simTypes: store.SimReducer.simTypes,
            telecoms: store.TelecomReducer.telecoms,
            telecomTypes: store.TelecomReducer.telecomTypes,
            variousMateriels: store.VariousMaterielReducer.variousMateriels,
            variousMaterielTypes: store.VariousMaterielReducer.variousMaterielTypes,
            equipments: store.EquipmentReducer.equipments,
            equipmentTypes: store.EquipmentReducer.equipmentTypes,
            subscriptions: store.SubscriptionReducer.subscriptions,
            subscriptionTypes: store.SubscriptionReducer.subscriptionTypes,
        },
    }), shallowEqual)

    const [event, setEvent] = useState({})
    const [diagnosticSolution, setDiagnosticSolution] = useState({})
    const [diagnosticSolutions, setDiagnosticSolutions] = useState([])
    const [isReadOnly, setIsReadOnly] = useState(true)
    const [mails, setMails] = useState(NO_MAILS)
    const [materielSituations, setMaterielSituations] = useState([])

    const {
        value: isPopupEmailOpen,
        setTrue: openEmailPopup,
        setFalse: closeEmailPopup,
    } = useBoolean(false)

    const isNew = code === '0'
    const isUnit = UNIT_TYPES.includes(type)

    const station = getStation({
        qualitometer, piezometer, pluviometer, hydrometricStation, productionUnit, distributionUnit, installation,
    }, type) ?? {}

    const fetchedEvent = execByType(type, {
        installation: () => installationEvent,
        productionUnit: () => productionUnitEvent,
        default: () => storeEvent,
    })

    const getInitialEvent = () => {
        const { date: dateParsed, campaignCode: campaignCodeParsed, campaignType, objectives } = queryString.parse(location.search)
        const date = dateParsed ? parseInt(dateParsed) : 0
        const campaignCode = campaignCodeParsed ? parseInt(campaignCodeParsed) : undefined
        const eventType = campaignType ?? EVENT_TYPES_CODES.CURATIVE
        const causeInterventions = objectives && CAUSE_INTERVENTION_TYPES.includes(type) && eventType !== EVENT_TYPES_CODES.NOT_DONE
            ? objectives.split(',').map(o => ({ interventionId: parseInt(o), interventionType: getInterventionType(eventType) }))
            : undefined
        return {
            code: parseInt(id),
            eventDate: date || moment().valueOf(),
            date: date || moment().valueOf(),
            endDate: moment().valueOf(),
            eventHour: moment().valueOf(),
            eventType,
            causeInterventions,
            graph: '0',
            chgtpiles: '0',
            bankExport: '0',
            razstation: '0',
            campaignCode,
        }
    }

    const onChangeEvent = (ref, value) => setEvent(prev => (
        isNil(value) || String(value) === '-1' ? deleteKeys(prev, [ref]) : { ...prev, [ref]: value }
    ))

    const onChangeEventType = newType => {
        setEvent(prev => {
            const keepCauses = newType !== EVENT_TYPES_CODES.NOT_DONE && getInterventionType(prev.eventType) === getInterventionType(newType)
            const keysToDelete = [
                ...(keepCauses ? [] : ['causeInterventions']),
                ...(newType === EVENT_TYPES_CODES.NOT_DONE ? [] : ['causeNonRealisation']),
            ]
            return {
                ...deleteKeys(prev, keysToDelete),
                eventType: newType,
                date: moment().valueOf(),
                eventDate: moment().valueOf(),
                endDate: moment().valueOf(),
                eventHour: moment().valueOf(),
            }
        })
        setDiagnosticSolutions(newType === fetchedEvent.eventType ? eventPiezometerActions : [])
    }

    const [inputKeys, setInputKeys] = useState({ date: 0, hour: 0, endHour: 0 })
    const hourDebounce = useRef(undefined)
    const endHourDebounce = useRef(undefined)

    useEffect(() => () => {
        if (hourDebounce.current) {
            clearTimeout(hourDebounce.current)
        }
        if (endHourDebounce.current) {
            clearTimeout(endHourDebounce.current)
        }
    }, [])

    const onChangeEventDate = v => onChangeDate(
        v,
        v2 => {
            const resolvedDate = v2 ?? moment().valueOf()
            setEvent(prev => (prev.eventType === EVENT_TYPES_CODES.COMMENT && v2 !== undefined ? {
                ...prev,
                date: resolvedDate,
                eventDate: resolvedDate,
                endDate: resolvedDate,
            } : {
                ...prev,
                date: resolvedDate,
                eventDate: resolvedDate,
            }))
            if (v2 === undefined) {
                setInputKeys(prev => ({ ...prev, date: prev.date + 1 }))
            }
        },
    )

    const commitEventHour = raw => {
        if (!event.date && !`${raw ?? ''}`.replace(/\D/g, '')) {
            return
        }
        onChangeHour(
            formatHourInput(raw),
            v2 => {
                setEvent(prev => ({ ...prev, date: v2, eventDate: v2, eventHour: v2 }))
                setInputKeys(prev => ({ ...prev, hour: prev.hour + 1 }))
            },
            undefined,
            safeBaseDate(event.date),
        )
    }

    const onChangeEventHour = v => {
        if (hourDebounce.current) {
            clearTimeout(hourDebounce.current)
        }
        hourDebounce.current = setTimeout(() => commitEventHour(v), 1000)
    }

    const onBlurEventHour = raw => {
        if (hourDebounce.current) {
            clearTimeout(hourDebounce.current)
        }
        commitEventHour(raw)
    }

    const commitEndHour = raw => {
        onChangeHour(
            formatHourInput(raw),
            v2 => {
                setEvent(prev => ({ ...prev, endDate: v2 }))
                setInputKeys(prev => ({ ...prev, endHour: prev.endHour + 1 }))
            },
            { min: event.date },
            safeBaseDate(event.endDate),
        )
    }

    const onChangeEndHour = v => {
        if (endHourDebounce.current) {
            clearTimeout(endHourDebounce.current)
        }
        endHourDebounce.current = setTimeout(() => commitEndHour(v), 500)
    }

    const onBlurEndHour = raw => {
        if (endHourDebounce.current) {
            clearTimeout(endHourDebounce.current)
        }
        commitEndHour(raw)
    }

    useEffect(() => {
        dispatch(StationAction.fetchProblems())
        dispatch(StationAction.fetchSolutions())
        dispatch(StationAction.fetchProblemSolutionLinks())
        dispatch(EventsAction.fetchPiezometerDiagnostics())
        dispatch(EventsAction.fetchPiezometerDiagnosticsLinkMaterials())
        dispatch(EventsAction.fetchPiezometerDiagnosticsLinkEventTypes())
        dispatch(EventsAction.fetchPiezometerSolutions())
        dispatch(EventsAction.fetchPiezometerSolutionsLinkProblems())
        dispatch(EventsAction.loadEventPanel())
        return () => {
            dispatch(EventsAction.resetEvent())
            dispatch(InstallationActionConstant.RESET_INSTALLATION_EVENT())
        }
    }, [])

    useEffect(() => {
        if (isNew) {
            setEvent(getInitialEvent())
            setIsReadOnly(false)
            return
        }
        execByType(type, {
            installation: () => dispatch(InstallationAction.fetchInstallationEvent(id, code)),
            productionUnit: () => dispatch(ProductionUnitAction.fetchProductionUnitEvent(id, code)),
            default: () => {
                dispatch(EventsAction.fetchEvent(type, id, code))
                dispatch(MaterielAction.fetchAllSituationByEvent(code, type, id)).then(jsonTab => setMaterielSituations(flatten([
                    jsonTab[0].map(e => ({ ...e, materielId: e.idEquipment, materielCategory: 'equipment' })),
                    jsonTab[1].map(c => ({ ...c, materielId: c.idCentral, materielCategory: 'central' })),
                    jsonTab[2].map(s => ({ ...s, materielId: s.idSensor, materielCategory: 'sensor' })),
                    jsonTab[3].map(ps => ({ ...ps, materielId: ps.idPowerSupply, materielCategory: 'powerSupply' })),
                    jsonTab[4].map(s => ({ ...s, materielId: s.idSim, materielCategory: 'sim' })),
                    jsonTab[5].map(t => ({ ...t, materielId: t.idTelecom, materielCategory: 'telecom' })),
                    jsonTab[6].map(vm => ({ ...vm, materielId: vm.idVarious, materielCategory: 'variousMateriel' })),
                    jsonTab[7].map(sub => ({ ...sub, materielId: sub.idSubscription, materielCategory: 'subscription' })),
                ])))
            },
        })
    }, [id, code, type])

    const resetFromStore = () => {
        setEvent(fetchedEvent)
        setIsReadOnly(true)
        if (!CAUSE_INTERVENTION_TYPES.includes(type)) return
        EventsAction.fetchStationCauseIntervention(type, id, code)
            .then((causeInterventions = []) => setEvent(prev => ({ ...prev, causeInterventions })))
    }

    useEffect(() => {
        if (isNew || !fetchedEvent.id) return
        resetFromStore()
    }, [fetchedEvent.id])

    useEffect(() => {
        setDiagnosticSolutions(prev => [...eventPiezometerActions, ...prev])
    }, [eventPiezometerActions.length])

    useEffect(() => {
        if (isUnit && event.eventType !== EVENT_TYPES_CODES.COMMENT) {
            setEvent(prev => ({ ...prev, eventType: EVENT_TYPES_CODES.COMMENT }))
        }
    }, [isUnit, event.eventType])

    useTitle(() => [{
        title: i18n[type],
        href: type,
    }, {
        title: getStationTitleWithTownName(station, citiesIndex[station.townCode]?.name),
        href: `station/${type}/${id}`,
    }, {
        title: i18n.journal,
        href: `station/${type}/${id}/event`,
    }, {
        title: isNew ? i18n.new : `${i18n.event} ${i18n.fromDate} ${getDate(event.date)}`,
        href: `station/${type}/${id}/event/${code}`,
    }], [type, id, code, isNew, station.name, station.townCode, citiesIndex, event.date])

    const onEventAdded = addedId => {
        dispatch(push(`/station/${type}/${id}/event/${addedId}`))
        setIsReadOnly(true)
    }

    const onDeleteEvent = () => {
        const onDeleted = () => dispatch(push(`/station/${type}/${id}/event/`))
        execByType(type, {
            installation: () => dispatch(InstallationAction.deleteInstallationEvent(id, installationEvent.number, onDeleted)),
            productionUnit: () => dispatch(ProductionUnitAction.deleteProductionUnitEvent(id, productionUnitEvent.number, onDeleted)),
            default: () => dispatch(EventsAction.deleteEvent(type, id, storeEvent.number, onDeleted)),
        })
    }

    const handleShare = socialNetwork => {
        if (socialNetwork.id === 'email') {
            openEmailPopup()
            return
        }
        if (socialNetwork.id === 'facebook') {
            dispatch(SieauAction.setPopup({
                id: uuidv4(),
                header: i18n.sharingConfirmation,
                actions: (
                    <div>
                        <a className='waves-effect waves-teal btn-flat modal-close'>{i18n.close}</a>
                        <a
                            className='waves-effect waves-teal btn-flat modal-close btn font-white'
                            onClick={() => dispatch(EventsAction.postFacebook(type, storeEvent.code, storeEvent.id))}
                        >
                            {i18n.validate}
                        </a>
                    </div>
                ),
            }))
        }
    }

    const getSharedTypes = () => {
        const types = [{
            id: 'email',
            onClick: handleShare,
            icon: 'email',
            label: i18n.email,
        }]
        const availablePostsTypes = [
            STATION_TYPE_NAME.piezometer,
            STATION_TYPE_NAME.piezometry,
            STATION_TYPE_NAME.quality,
            STATION_TYPE_NAME.qualitometer,
        ]
        if (!availablePostsTypes.includes(type)) return types

        const idContributors = (station.contributors || []).map(c => c.idContributor)
        const fbContributor = contributors.find(c => idContributors.includes(c.id) && c.name.toLowerCase() === 'facebook')
        return fbContributor ? [{
            id: 'facebook',
            onClick: handleShare,
            img: 'assets/pictures/socialNetworks/logo_facebook.png',
            label: 'Facebook',
        }, ...types] : types
    }

    const onSave = () => {
        const isNotDone = event.eventType === EVENT_TYPES_CODES.NOT_DONE
        if (isNotDone && isNil(event.causeNonRealisation)) {
            dispatch(ToastrAction.error(i18n.pleaseCompleteAllRequiredField))
            return
        }
        if (hasControlMeasures && hasInvalidControls(event.controls)) {
            dispatch(ToastrAction.error(i18n.controlDateRequired))
            return
        }
        const eventWithControls = hasControlMeasures ? {
            ...event,
            controls: getControlsToSave(event.controls),
            ns: type === STATION_TYPE_NAME.hydrometry ? getLevelControl(type, event.controls)?.value : event.ns,
        } : event
        const eventToSave = isNotDone ? { ...eventWithControls, causeInterventions: [], bankExport: '0' } : eventWithControls
        const eventWithDiagnostic = {
            event: {
                ...eventToSave,
                endDate: eventToSave.endDate || getDateWithHour(eventToSave.date, eventToSave.eventHour).valueOf(),
            },
            diagnostics: diagnosticSolutions,
        }
        if (isNew) {
            execByType(type, {
                installation: () => dispatch(InstallationAction.addInstallationEvent(id, eventToSave, onEventAdded)),
                productionUnit: () => dispatch(ProductionUnitAction.addProductionUnitEvent(id, eventToSave, onEventAdded)),
                piezometry: () => dispatch(EventsAction.createPiezometryEventWithDiagnostic(id, eventWithDiagnostic)),
                default: () => dispatch(EventsAction.addEvent(type, id, eventToSave)).then(onEventAdded),
            })
            return
        }
        execByType(type, {
            installation: () => dispatch(InstallationAction.updateInstallationEvent(id, code, eventToSave, () => setIsReadOnly(true))),
            productionUnit: () => dispatch(ProductionUnitAction.updateProductionUnitEvent(id, code, eventToSave, () => setIsReadOnly(true))),
            piezometry: () => dispatch(EventsAction.updatePiezometryEventWithDiagnostic(id, code, eventWithDiagnostic)),
            default: () => dispatch(EventsAction.updateEvent(type, id, code, eventToSave)).then(() => setIsReadOnly(true)),
        })
    }

    useActions(() => {
        const isConsultant = getUser().consultant === '1'
        if (isNew) {
            return isConsultant ? {} : { save: onSave }
        }
        if (isReadOnly) {
            const actions = {
                edit: () => {
                    setIsReadOnly(false)
                },
                delete: onDeleteEvent,
            }
            return isConsultant ? omit(actions, ['delete', 'edit']) : actions
        }
        const actions = {
            save: onSave,
            cancel: () => {
                setDiagnosticSolutions([...eventPiezometerActions])
                resetFromStore()
            },
            clear: () => {
                setEvent(getInitialEvent())
                setDiagnosticSolutions([])
            },
            delete: onDeleteEvent,
            share: getSharedTypes(),
        }
        return isConsultant ? omit(actions, ['save', 'clear', 'delete']) : actions
    }, [isNew, isReadOnly, event, diagnosticSolutions, fetchedEvent, eventPiezometerActions, type, id, code, station, contributors])

    const getFilterDiagnostics = () => {
        const stationMaterielType = [
            stationCentral.length && 1,
            stationSensor.length && 2,
            stationPowerSupply.length && 3,
            stationSim.length && 4,
            stationVariousMateriel.length && 5,
            stationTelecom.length && 6,
            stationEquipment.length && 7,
        ].filter(t => !!t)

        const filteredByMateriel = stationMaterielType.length
            ? eventPiezometerDiagnostics.filter(diag => eventPiezometerDiagnosticsLinkMaterials.find(l => l.codeDiagnostic === diag.codeDiagnostic && stationMaterielType.includes(l.materialType)))
            : eventPiezometerDiagnostics
        const eventType = EVENT_TYPES.find(e => e.code === event.eventType) || {}
        return filteredByMateriel.filter(diag => eventPiezometerDiagnosticsLinkEventTypes.find(l => l.codeDiagnostic === diag.codeDiagnostic && l.eventType === eventType.id))
    }

    const addDiagnosticSolution = action => {
        const { diagnostic, solution } = diagnosticSolution
        if (!diagnostic?.codeDiagnostic || !solution?.codeSolution) {
            dispatch(ToastrAction.error(i18n.error))
            return
        }
        setDiagnosticSolutions(prev => {
            const actionId = action.actionId || (prev.length ? maxBy(prev, 'actionId').actionId + 1 : 1)
            return [
                ...prev.filter(d => d.actionId !== action.actionId),
                {
                    diagnosticCode: diagnostic.codeDiagnostic,
                    solutionCode: solution.codeSolution,
                    actionId,
                },
            ]
        })
    }

    const getPopupDiagnosticAction = (action = {}) => {
        setDiagnosticSolution({})
        dispatch(SieauAction.setPopup({
            id: uuidv4(),
            header: i18n.problems,
            actions: (
                <div>
                    <a className='waves-effect waves-teal btn-flat modal-close'>{i18n.close}</a>
                    <a className='waves-effect waves-teal btn-flat modal-close' onClick={() => addDiagnosticSolution(action)}>{i18n.validate}</a>
                </div>
            ),
            dismissible: false,
            content: (
                <DiagnosticSolutionModal
                    diagnostics={getFilterDiagnostics()}
                    solutions={eventPiezometerSolutions}
                    linkDiagnosticSolution={eventPiezometerSolutionsLinkProblems}
                    addDiagnosticSolution={obj => setDiagnosticSolution(prev => ({ ...prev, ...obj }))}
                    action={action}
                />
            ),
        }))
    }

    const getCampaigns = () => {
        const campaigns = execByType(type, {
            pluviometry: () => pluviometryCampaigns,
            hydrometry: () => hydrometryCampaigns,
            quality: () => qualityCampaigns,
            installation: () => installationCampaigns,
            default: () => undefined,
        })
        const campaignStations = execByType(type, {
            pluviometry: () => pluviometryCampaignStations,
            hydrometry: () => hydrometryCampaignStations,
            quality: () => qualityCampaignStations,
            installation: () => installationCampaignStations,
            default: () => undefined,
        })

        if (!campaigns && !campaignStations) return undefined

        const campaignIds = campaignStations.filter(({ stationId }) => stationId === station.id).map(({ campaignId }) => campaignId)
        return uniq(campaignIds.map(campaignId => campaigns.find(({ id: currentId }) => campaignId === currentId)).filter(c => !!c))
    }

    const disabled = { disabled: isReadOnly, active: !isReadOnly }
    const eventSelection = event.eventType || EVENT_TYPES_CODES.COMMENT

    const eventTypeList = useMemo(() => [
        { code: 'G', name: i18n.preventive },
        { code: 'M', name: i18n.curative },
        { code: 'P', name: i18n.toPlan },
        { code: 'S', name: i18n.toMonitor },
        { code: 'C', name: i18n.comment },
        ...(CAUSE_INTERVENTION_TYPES.includes(type) ? [{ code: EVENT_TYPES_CODES.NOT_DONE, name: i18n.notDoneIntervention }] : []),
    ], [type])

    const getCampaignsField = () => {
        const campaigns = getCampaigns()
        if (!campaigns) return null
        const { options: campaignOptions, optionsGroups: campaignGroups } = buildCampaignGroups(campaigns, sandreCodes)
        return (
            <Grid size={5}>
                <SuperMultiAutocomplete
                    label={i18n.campaign}
                    values={event.campaignCode}
                    options={campaignOptions}
                    optionsGroups={campaignGroups}
                    noSort
                    onChange={campaignId => onChangeEvent('campaignCode', campaignId)}
                    {...disabled}
                />
            </Grid>
        )
    }

    const getInstallationDiagnosticForm = () => {
        if (type !== STATION_TYPE_NAME.installation) return null
        const form = [
            <Grid size={3} key='diagnostic'>
                <Checkbox
                    label={i18n.diagnosticDone}
                    checked={event.diagnostic}
                    onChange={diagnosticDone => setEvent(prev => ({
                        ...prev,
                        diagnostic: diagnosticDone,
                        diagnosticDeadline: diagnosticDone ? moment().year(moment().year() + 10).valueOf() : prev.diagnosticDeadline,
                    }))}
                    {...disabled}
                />
            </Grid>,
        ]
        return event.diagnostic ? [
            ...form,
            <Grid size={3} key='diagnosticDeadline'>
                <DatePicker
                    id='diagnosticDeadline'
                    title={i18n.diagnosticDeadline}
                    value={event.diagnosticDeadline}
                    mustHaveValue
                    onChange={(_, v) => onChangeEvent('diagnosticDeadline', v)}
                    {...disabled}
                />
            </Grid>,
        ] : form
    }

    /* à supprimer ? la table s'affiche quand ce n'est pas un piezo mais la card s'affiche quand c'est un piezo l.645 */
    const getTableIntervention = () => {
        if (type !== STATION_TYPE_NAME.piezometry || !diagnosticSolutions.length) return null
        const data = diagnosticSolutions.map(elem => {
            const diagnostic = eventPiezometerDiagnostics.find(d => elem.diagnosticCode === d.codeDiagnostic) || {}
            const solution = eventPiezometerSolutions.find(s => elem.solutionCode === s.codeSolution) || {}
            return {
                diagnosticCode: elem.diagnosticCode,
                solutionCode: elem.solutionCode,
                actionId: elem.actionId,
                diagnostic: diagnostic.description,
                action: solution.description,
                nullValue: <Icon icon='arrow_forward' size='small' />,
            }
        })
        return (
            <Table
                showTitle={false}
                sortable
                type={{ headers: ['diagnostic', 'nullValue', 'action'] }}
                data={data}
                alterable={disabled.active}
                onAlter={getPopupDiagnosticAction}
                deletable={disabled.active}
                onDelete={action => setDiagnosticSolutions(prev => prev.filter(d => action.actionId !== d.actionId))}
            />
        )
    }

    const getUpdateInfo = () => (storeEvent.updateDate && storeEvent.updateLogin ? (
        <Grid size={8}>
            <LastUpdateCard element={storeEvent} withHour />
        </Grid>
    ) : null)

    const getPreventiveCard = () => {
        if (eventSelection !== 'G' && eventSelection !== 'M') return null
        const panel = execByType(type, {
            installation: () => (
                <Grid size={2}>
                    <NumberField title={i18n.staticLevel} floatValue value={event.ns} col={2} onChange={v => onChangeEvent('ns', v)} {...disabled} />
                </Grid>
            ),
            default: () => (
                <Stack spacing={1}>
                    <Grid container spacing={1}>
                        <Grid size={3}>
                            <Checkbox label={i18n.chgtpiles} checked={event.chgtpiles === '1'} onChange={e => onChangeEvent('chgtpiles', e ? '1' : '0')} {...disabled} />
                        </Grid>
                        <Grid size={3}>
                            <Checkbox label={i18n.razstation} checked={event.razstation === '1'} onChange={e => onChangeEvent('razstation', e ? '1' : '0')} {...disabled} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid size={2}>
                            <NumberField title={i18n.volt} floatValue value={event.volt} onChange={v => onChangeEvent('volt', v)} {...disabled} />
                        </Grid>
                        <Grid size={2}>
                            <NumberField title={i18n.valeurcalee} floatValue value={event.valeurcalee} onChange={v => onChangeEvent('valeurcalee', v)} {...disabled} />
                        </Grid>
                        <Grid size={2}>
                            <NumberField title={i18n.sondeTemperature} floatValue value={event.sondeTemperature} onChange={v => onChangeEvent('sondeTemperature', v)} {...disabled} />
                        </Grid>
                        <Grid size={2}>
                            <NumberField title={i18n.centralTemperature} floatValue value={event.centralTemperature} onChange={v => onChangeEvent('centralTemperature', v)} {...disabled} />
                        </Grid>
                        {!hasControlMeasures && (
                            <Grid size={2}>
                                <NumberField title={i18n.staticLevel} floatValue value={event.ns} onChange={v => onChangeEvent('ns', v)} {...disabled} />
                            </Grid>
                        )}
                        <Grid size={2}>
                            <NumberField title={i18n.centralLevel} floatValue value={event.nc} onChange={v => onChangeEvent('nc', v)} {...disabled} />
                        </Grid>
                    </Grid>
                </Stack>
            ),
        })
        return (
            <Card>
                <CardTitle title={i18n.preventiveData} color={darkBlue} />
                <CardContent>
                    {panel}
                </CardContent>
            </Card>
        )
    }

    if (!event.date) return null

    /* à supprimer ? cf. l.570 */
    const cardIntervention = event.eventType && event.eventType !== EVENT_TYPES_CODES.COMMENT && type === STATION_TYPE_NAME.piezometry ? (
        <Card
            title={i18n.intervention}
            {...disabled}
            maxWidth={1200}
            actions={[{ iconName: 'node_add', onClick: () => getPopupDiagnosticAction() }]}
        >
            {getTableIntervention()}
        </Card>
    ) : null

    return (
        <Stack padding={1} spacing={1}>
            <Grid container justifyContent={'center'}>
                {getUpdateInfo()}
            </Grid>
            <Grid container justifyContent={'center'}>
                <Grid size={8}>
                    <Card sx={{ display: !isUnit ? 'block' : 'none' }} >
                        <CardTitle title={i18n.interventionType} color={darkBlue} />
                        <CardContent>
                            <Stack spacing={1}>
                                <RadioButtons
                                    elements={eventTypeList}
                                    title={i18n.type}
                                    selected={eventSelection}
                                    onChange={onChangeEventType}
                                    {...disabled}
                                />
                                {CAUSE_INTERVENTION_TYPES.includes(type) && (
                                    <Grid container>
                                        <Grid size={6}>
                                            {eventSelection === EVENT_TYPES_CODES.NOT_DONE ? (
                                                <Select
                                                    label={i18n.causeNonRealisation}
                                                    options={getSandreList(sandreCodes, SANDRE.CAUSE_NON_REALISATION)}
                                                    value={event.causeNonRealisation}
                                                    onChange={v => onChangeEvent('causeNonRealisation', v)}
                                                    keyValue='code'
                                                    keyLabel='name'
                                                    integerValue
                                                    obligatory
                                                    {...disabled}
                                                />
                                            ) : (
                                                <SuperMultiAutocomplete
                                                    label={i18n.causeIntervention}
                                                    options={getSandreList(sandreCodes, `CAUSE_INTERVENTION.${getInterventionType(eventSelection)}`)}
                                                    values={(event.causeInterventions ?? []).map(({ interventionId }) => interventionId)}
                                                    onChange={list => onChangeEvent('causeInterventions', list.map(interventionId => ({
                                                        interventionId,
                                                        interventionType: getInterventionType(eventSelection),
                                                    })))}
                                                    multiple
                                                    limit={4}
                                                    noSort
                                                    keyValue='code'
                                                    keyLabel='name'
                                                    data-cy='causeIntervention'
                                                    {...disabled}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                )}
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container justifyContent={'center'}>
                <Grid size={8}>
                    <Card>
                        <CardTitle title={i18n.event} color={darkBlue} />
                        <CardContent>
                            <Stack spacing={1}>
                                <Grid container spacing={1}>
                                    <Grid size={2}>
                                        <Input
                                            key={`eventDate-${inputKeys.date}`}
                                            title={i18n.date}
                                            value={getDate(event.date)}
                                            onChange={onChangeEventDate}
                                            {...disabled}
                                            data-cy='dateEvent'
                                        />
                                    </Grid>
                                    <Grid size={2}>
                                        <Input
                                            key={`eventHour-${event.date ? '1' : '0'}-${inputKeys.hour}`}
                                            title={i18n.hour}
                                            value={event.date ? getHour(event.eventHour) : ''}
                                            onChange={onChangeEventHour}
                                            otherInputProps={{ onBlur: e => onBlurEventHour(e.target.value) }}
                                            {...disabled}
                                            data-cy='hourEvent'
                                        />
                                    </Grid>
                                    <Grid size={2}>
                                        <Input
                                            title={i18n.endDate}
                                            value={getDate(event.endDate)}
                                            onChange={v => onChangeDate(v, v2 => onChangeEvent('endDate', v2), { min: event.date })}
                                            {...disabled}
                                            data-cy='endDateEvent'
                                        />
                                    </Grid>
                                    <Grid size={2}>
                                        <Input
                                            key={`endHour-${inputKeys.endHour}`}
                                            title={i18n.hour}
                                            value={getHour(event.endDate)}
                                            onChange={onChangeEndHour}
                                            otherInputProps={{ onBlur: e => onBlurEndHour(e.target.value) }}
                                            {...disabled}
                                            data-cy='endHourEvent'
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <Select
                                            options={contacts}
                                            label={i18n.referent}
                                            value={event.contactCode}
                                            nullLabel={i18n.none}
                                            onChange={v => onChangeEvent('contactCode', v)}
                                            {...disabled}
                                        />
                                    </Grid>
                                </Grid>
                                <Textarea
                                    title={i18n.comment}
                                    value={event.comment}
                                    onChange={v => onChangeEvent('comment', v)}
                                    {...disabled}
                                />
                                {type !== STATION_TYPE_NAME.distributionUnit && (
                                    <Grid container spacing={1} alignItems={'center'}>
                                        {getCampaignsField()}
                                        {type !== STATION_TYPE_NAME.installation && [
                                            <Grid key='graph' size={3}><Checkbox label={i18n.displayGraph} checked={event.graph === '1'} onChange={e => onChangeEvent('graph', e ? '1' : '0')} {...disabled} /></Grid>,
                                            eventSelection !== EVENT_TYPES_CODES.NOT_DONE && <Grid key='bankExport' size={4}><Checkbox label={i18n.bankExport} checked={event.bankExport === '1'} onChange={e => onChangeEvent('bankExport', e ? '1' : '0')} {...disabled} /></Grid>,
                                        ]}
                                        {getInstallationDiagnosticForm()}
                                    </Grid>
                                )}
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            {!!materielSituations.length && (
                <Grid container justifyContent={'center'}>
                    <Grid size={8}>
                        <Card>
                            <CardTitle title={i18n.materiel} color={darkBlue} />
                            <CardContent>
                                {materielSituations.map(({ materielCategory, materielId, statusCode }, i) => {
                                    const materiel = materiels[getMaterielPlural(materielCategory)].find(m => m.id === materielId)
                                    if (isNil(materiel)) return null

                                    const materielType = materiels[`${materielCategory}Types`].find(t => t.materielType === materiel.materielType)
                                    const matState = materielStates.find(s => s.code === statusCode) || {}
                                    const matStateIcon = getMaterialStateIcon(matState.code)
                                    return (
                                        <ElementCard
                                            key={i}
                                            icon={matStateIcon.icon}
                                            iconColor={matStateIcon.color}
                                            color='white'
                                            style={{ color: statusCode === 1 ? 'dodgerBlue' : 'red' }}
                                        >
                                            {`${upperFirst(matState.label)}: ${upperFirst(materielCategory)} ${materielType ? `${materielType.name} - ` : ''}${materiel.numLine || materiel.imei || materiel.serialNumber || ''}`}
                                        </ElementCard>
                                    )
                                })}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            <Grid container justifyContent={'center'}>
                <Grid size={8}>
                    {getPreventiveCard()}
                </Grid>
            </Grid>
            {hasControlMeasures && (eventSelection === 'G' || eventSelection === 'M') && (
                <Grid container justifyContent={'center'}>
                    <Grid size={8}>
                        <EventControlMeasuresCard
                            stationType={type}
                            stationId={parseInt(id)}
                            controls={event.controls}
                            onChange={controls => onChangeEvent('controls', controls)}
                            eventDate={getDateWithHour(event.date, event.eventHour)?.valueOf()}
                            disabled={disabled.disabled}
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container justifyContent={'center'}>
                <Grid size={8}>
                    <Card>
                        <CardTitle title={i18n.photos} color={darkBlue} />
                        <CardContent />
                    </Card>
                </Grid>
            </Grid>
            {/* à supprimer ? cf. l.657 && l.570 */}
            {cardIntervention}
            <Dialog onClose={closeEmailPopup} fullWidth maxWidth='md' open={isPopupEmailOpen}>
                <DialogContent>
                    <SelectEmail
                        mailContacts={mails.mailContacts}
                        mailContributors={mails.mailContributors}
                        mailCities={mails.mailCities}
                        mailReceivers={mails.mailReceivers}
                        onChangeEmails={newMails => setMails(prev => ({ ...prev, ...newMails }))}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeEmailPopup} variant='outlined' >
                        {i18n.close}
                    </Button>
                    <Button
                        onClick={() => {
                            dispatch(EventsAction.sendEventByMail(type, id, code, [
                                ...mails.mailContacts,
                                ...mails.mailContributors,
                                ...mails.mailReceivers,
                                ...mails.mailCities,
                            ]))
                            closeEmailPopup()
                        }}
                        variant='contained'
                        color='primary'
                    >
                        {i18n.send}
                    </Button>
                </DialogActions>
            </Dialog>
        </Stack>
    )
}

StationEventApp.propTypes = {
    type: PropTypes.string,
}

export default StationEventApp
